import { getLocale } from "@utils/configuration/aem";
import { isDefined } from "@utils/helpers";

export const fetchLocalityDetails = async (
    LocalitiesService: woosmap.map.LocalitiesService,
    id: string
) => LocalitiesService.getDetails({
    publicId: id,
    language: getLocale(),
}).then(({ result }) => {
    if (!isDefined(result.geometry)) throw new Error();

    return result;
})

export const fetchLocalityGeocode = async (
    LocalitiesService: woosmap.map.LocalitiesService,
    latLng: woosmap.map.LatLngLiteral
) => LocalitiesService.geocode({
    latLng: latLng,
}).then(({ results }) => {
    const result = results.at(0);

    if (!isDefined(result)) throw new Error();

    return result;
});
